import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withKeys as _withKeys, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "maz-select__tag__text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "maz-select__tag__clear material-icons" }, " close ", -1)
const _hoisted_3 = {
  class: "maz-select__toggle maz-flex maz-flex-center",
  tabindex: "-1"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  mlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  class: "maz-select__toggle__arrow"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "arrow",
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  })
], -1)
const _hoisted_5 = {
  ref: "optionsList",
  class: "maz-select__options-list__items maz-flex maz-direction-column"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "maz-select__options-list__no-results maz-p-1 maz-flex maz-flex-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons maz-text-danger" }, " search_off ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MazBtn = _resolveComponent("MazBtn")!
  const _component_MazInput = _resolveComponent("MazInput")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["maz-base-component maz-select", [{
      'has-list-open': _ctx.hasOpenList,
      'maz-is-dark': _ctx.dark
    }, `maz-select--${_ctx.color}`, `maz-select--${_ctx.size}`]]),
    onBlurCapture: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeList($event))),
    ref: "root"
  }, [
    (_ctx.multiple)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "SelectedTags",
          class: _normalizeClass(["maz-select__tags maz-flex maz-align-center", {
        'maz-left-offset': _ctx.hasLeftIcon
      }])
        }, [
          _createVNode(_TransitionGroup, {
            ref: "SelectedTagsContainer",
            tag: "div",
            name: "maz-tags",
            class: "maz-flex maz-align-center maz-h-100"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOptions, (option, i) => {
                return (_openBlock(), _createBlock(_component_MazBtn, {
                  key: `tags-${i}`,
                  class: "maz-select__tag maz-flex maz-align-center",
                  disabled: _ctx.disabled,
                  color: _ctx.color,
                  size: _ctx.size,
                  onClick: _withModifiers(($event: any) => (_ctx.removeOption(option[_ctx.config.valueKey])), ["prevent","stop"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(option[_ctx.config.labelKey]), 1),
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["disabled", "color", "size", "onClick"]))
              }), 128))
            ]),
            _: 1
          }, 512)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_MazInput, _mergeProps({
      ref: "textField",
      modelValue: _ctx.valueShown
    }, _ctx.$attrs, {
      readonly: "",
      "no-label": _ctx.hasNoLabel,
      color: _ctx.color,
      size: _ctx.size,
      placeholder: _ctx.placeholderShown,
      disabled: _ctx.disabled,
      focus: _ctx.hasOpenList,
      onClear: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitValues(null))),
      onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search ? null : _ctx.keyboardNav($event))),
      onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('keyup', $event))),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('blur', $event))),
      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('change', $event))),
      onPaste: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('paste', $event))),
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('click', $event))),
      onFocus: _ctx.openList
    }), {
      "icon-right": _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "arrow", {}, () => [
            _hoisted_4
          ])
        ])
      ]),
      _: 3
    }, 16, ["modelValue", "no-label", "color", "size", "placeholder", "disabled", "focus", "onFocus"]),
    _createVNode(_Transition, { name: _ctx.listTransition }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["maz-select__options-list maz-flex maz-elevation", [
          _ctx.hasPositionTop ? 'maz-select__options-list--top maz-direction-column-reverse' : 'maz-direction-column',
          { 'maz-select__options-list--right': _ctx.hasPositionRight }
        ]]),
          style: _normalizeStyle([_ctx.itemListSize])
        }, [
          (_ctx.search)
            ? (_openBlock(), _createBlock(_component_MazInput, {
                key: 0,
                ref: "SearchInput",
                color: _ctx.color,
                modelValue: _ctx.searchQuery,
                placeholder: _ctx.searchPlaceholder,
                size: "sm",
                "no-label": "",
                name: "new_search_in_options",
                autocomplete: "off",
                class: "maz-m-1",
                "onUpdate:modelValue": _ctx.searchInOptions,
                onKeydown: [
                  _ctx.keyboardNav,
                  _withKeys(_ctx.closeList, ["esc"])
                ]
              }, null, 8, ["color", "modelValue", "placeholder", "onUpdate:modelValue", "onKeydown"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsShown, (option, i) => {
              return (_openBlock(), _createElementBlock("button", {
                key: i,
                tabindex: "-1",
                type: "button",
                class: _normalizeClass([[
              {'selected': _ctx.values.length && _ctx.values.includes(option[_ctx.config.valueKey]) },
              {'keyboard-selected': _ctx.tmpValue === option[_ctx.config.valueKey]}
            ], "maz-select__options-list__item flex maz-align-center maz-text-left"]),
                style: _normalizeStyle([_ctx.optionHeight]),
                onClick: _withModifiers(($event: any) => (_ctx.updateValue(option[_ctx.config.valueKey])), ["prevent","stop"])
              }, [
                _renderSlot(_ctx.$slots, "default", {
                  option: { ...option, isSelected: _ctx.values.includes(option[_ctx.config.valueKey]) },
                  tag: "div"
                }, () => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["maz-dots-text", [
                  { 'maz-text-muted' : !option[_ctx.config.valueKey] },
                  _ctx.values.includes(option[_ctx.config.valueKey]) ? 'maz-text-white' : 'maz-text-color'
                ]])
                  }, _toDisplayString(option[_ctx.config.labelKey]), 3)
                ])
              ], 14, _hoisted_6))
            }), 128)),
            (!_ctx.optionsShown.length)
              ? _renderSlot(_ctx.$slots, "no-results", {
                  key: 0,
                  tag: "div"
                }, () => [
                  _hoisted_7
                ])
              : _createCommentVNode("", true)
          ], 512)
        ], 6), [
          [_vShow, _ctx.hasOpenList]
        ])
      ]),
      _: 3
    }, 8, ["name"])
  ], 34))
}